import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { ToastModule } from 'primeng/toast';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { SelectModule } from 'primeng/select';
import { TextareaModule } from 'primeng/textarea';
import { FluidModule } from 'primeng/fluid';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { ScreenMasterViewModel } from '../viewmodels/screen-master.viewmodel';
import { ScreenMasterService } from '../services/screen-master.service';
import { ToastService } from '../../../toast/toast.service';
import { AuthService } from '../../../auth/login/services/auth.service';

@Component({
  selector: 'app-screen-master',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    TableModule,
    ButtonModule,
    DialogModule,
    InputTextModule,
    TooltipModule,
    ToastModule,
    ConfirmDialogModule,
    SelectModule,
    TextareaModule,
    FluidModule,
    IconFieldModule,
    InputIconModule
  ],
  providers: [ConfirmationService],
  templateUrl: './screen-master.component.html',
  styleUrls: ['./screen-master.component.scss']
})
export class ScreenMasterComponent implements OnInit {
  viewModel: ScreenMasterViewModel;

  constructor(
    private toastService: ToastService,
    private confirmationService: ConfirmationService,
    private screenMasterService: ScreenMasterService,
    private router: Router,
    private authService: AuthService
  ) {
    this.viewModel = new ScreenMasterViewModel(
      this.screenMasterService,
      this.toastService,
      this.router,
      this.confirmationService,
      this.authService
    );
  }

  ngOnInit(): void {
    this.viewModel.init();
  }
}
